/*
 * Pestaña Clientes y Directores: top 15 clientes y pendiente por director de cuenta.
 */
import { useMemo } from "react";
import { SimpleHorizontalChart } from "codekit";

import Panelbox from "./Panelbox";
import { fmtMillions, groupSum, toMillions } from "./utils/carthelp";

/**
 * Ordena un mapa de sumas en filas para SimpleHorizontalChart (escala en millones)
 * @param {Object} mMap Mapa clave → valor
 * @param {number} nTop Máximo de filas
 * @returns {Array} Filas [{ name, value, sideLabel }]
 */
const toHBars = (mMap, nTop) =>
  Object.entries(mMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, nTop)
    .map(([sLabel, nValue]) => ({ name: sLabel, value: toMillions(nValue), sideLabel: fmtMillions(nValue) }));

/**
 * Renderiza la pestaña Clientes y Directores
 * @param {Object} props Propiedades del componente
 * @param {Array} props.data Datos de trabajo filtrados
 */
const Tabclien = ({ data }) => {
  const mClientes = useMemo(() => toHBars(groupSum(data, "NOMBRE"), 15), [data]);
  const mDirectores = useMemo(() => toHBars(groupSum(data, "DIRECTOR DE CUENTA"), 20), [data]);

  return (
    <>
      <Panelbox title="Top 15 Clientes por Valor Pendiente" hint="Mayor exposición de facturación pendiente">
        <SimpleHorizontalChart subtitle="Cifras en millones de COP" barColor="secondary-600" maxItems={8} data={mClientes} />
      </Panelbox>
      <Panelbox title="Pendiente por Director de Cuenta" hint="Responsable comercial de cada cliente">
        <SimpleHorizontalChart subtitle="Cifras en millones de COP" barColor="primary-600" maxItems={8} data={mDirectores} />
      </Panelbox>
    </>
  );
};

export default Tabclien;
